import { render, staticRenderFns } from "./ThreadPostPlaceholder.vue?vue&type=template&id=6505f411&scoped=true&"
import script from "./ThreadPostPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ThreadPostPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ThreadPostPlaceholder.vue?vue&type=style&index=0&id=6505f411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505f411",
  null
  
)

export default component.exports